<script>
import { formatNumber } from '@ubic/utils/formatters';
import IconGhost from '@/components/icons/Ghost';

export default {
  props: {
    fetchWorkers: {
      type: Function,
      required: true,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isFetching: false,
      data: [],
      maxHours: 0,
      totalHours: 0,
    };
  },
  watch: {
    filter () {
      this.fetchData();
    },
  },
  methods: {
    async fetchData () {
      const response = await this.fetchWorkers(this.filter);
      this.data = Object.freeze(response.data);
      this.maxHours = response.meta.maxHours;
      this.totalHours = response.meta.totalHours;
    },
  },
  async created () {
    this.isFetching = true;

    await this.fetchData();

    this.isFetching = false;
  },
  render () {
    if (this.isFetching) {
      return <u-spinner />;
    }

    const { $style, data, maxHours, totalHours } = this;

    return (
      <div>
        {!data.length && (
          <div class={$style.empty}>
            <span class={$style.emptyIcon}>
              <IconGhost />
            </span>
            <span>
              Ничего не найдено
            </span>
          </div>
        )}
        {data.map(worker => (
          <div
            key={worker.id}
            class={$style.worker}
          >
            <div class={$style.workerInfo}>
              <span
                class={$style.workerDepartmentColor}
                style={{ color: worker.department.color }}
              />
              <span class={$style.workerName}>
                {worker.name}
              </span>
              <span class={$style.workerHours}>
                {formatNumber(worker.totalHours, { round: 2 })}
                ч
              </span>
              <span class={$style.workerPercentage}>
                {formatNumber(
                  100 * (worker.totalHours / totalHours),
                  { round: 2 },
                )}
                %
              </span>
            </div>
            <div
              class={$style.workerPayload}
              style={{ width: `${100 * (worker.totalHours / maxHours)}%` }}
            />
          </div>
        ))}
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.empty {
  align-items: center;
  color: $color-gray;
  display: flex;

  &Icon {
    color: $color-gray-lighter;
    font-size: 4em;
    margin-right: .5em;
  }
}

.worker {
  & + & {
    margin-top: 1em;
  }

  &Info {
    align-items: center;
    display: flex;
    margin-bottom: .25em;
  }

  &DepartmentColor {
    background-color: currentColor;
    border-radius: 50%;
    display: inline-block;
    font-size: .75rem;
    height: 1em;
    margin-right: .5em;
    width: 1em;
  }

  &Name {
    width: 160px;
  }

  &Hours {
    font-weight: bold;
    text-align: right;
    width: 80px;
  }

  &Percentage {
    font-size: .825em;
    text-align: right;
    width: 60px;
  }

  &Payload {
    background-color: $color-gray;
    border-radius: .25em;
    height: .5em;
  }
}
</style>
